import {
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts";
import { CustomLegend, CustomTooltip } from "../reusables/ReusableChartComponents";

export interface LineChartData {
    name: string;
    "Doanh thu": number;
}

export const LineChartComponent = ({ data }: { data: LineChartData[] }) => {
    return (
        <ResponsiveContainer width="100%" height={510}>
            <LineChart
                data={data}
                margin={{ top: 5, right: 40, left: 60, bottom: 5 }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                <Legend content={<CustomLegend />} />
                <Line
                    type="monotone"
                    dataKey="Doanh thu"
                    stroke="#FD1F9B"
                    strokeWidth={1.811}
                />
            </LineChart>
        </ResponsiveContainer>
    );
};
